import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const AiIcon = (props: IconProps) => {
  return (
    <Icon
      enableBackground="new 0 0 24 24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.2584 1C8.5504 1 4.75404 4.60556 4.51676 9.14L2.11906 12.2322C1.81935 12.6111 2.11906 13.2222 2.64356 13.2222H4.51676V16.8889C4.51676 18.2456 5.6282 19.3333 7.01437 19.3333H8.26317V23H17.0048V17.2678C19.9645 15.8989 22 12.9778 22 9.55556C22 4.83778 18.1037 1 13.2584 1ZM18.3285 9.03L15.8809 9.66556L17.6791 11.4378C18.1162 11.8533 18.1162 12.5622 17.6791 12.99C17.2421 13.4178 16.5178 13.4178 16.0932 12.99L14.2699 11.23L13.633 13.6256C13.4832 14.2244 12.8588 14.5667 12.2718 14.4078C11.6599 14.2489 11.3103 13.65 11.4726 13.0633L12.1345 10.6556L9.67432 11.3033C9.07489 11.4622 8.45049 11.12 8.30064 10.5211C8.13829 9.94667 8.48796 9.33556 9.09987 9.18889L11.5475 8.56556L9.74925 6.78111C9.31217 6.36556 9.31217 5.66889 9.74925 5.22889C10.1863 4.80111 10.9106 4.80111 11.3352 5.22889L13.146 6.98889L13.7954 4.59333C13.9452 4.00667 14.5571 3.66444 15.1316 3.81111C15.756 3.97 16.1057 4.56889 15.9558 5.16778L15.2939 7.56333L17.7416 6.91556C18.3535 6.76889 18.9654 7.11111 19.1278 7.72222C19.2776 8.28444 18.9279 8.88333 18.3285 9.03Z"
          fill="#2833AA"
        />
      </svg>
    </Icon>
  );
};

export default AiIcon;
